import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const NoOfSleepers = ({ noOfSleepers }: SpecProps<"no_of_sleepers">) => {
  const { i18n } = useLingui();

  if (noOfSleepers == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.common.numberOfSleepers",
    message: "Number of sleepers",
    comment: "Field for 'number of sleepers' in ad specification",
  });
  return <FieldValuePair field={field} value={noOfSleepers} />;
};
